"use client";

import GlassCard, {
  glassCardVariants,
} from "@/components/creations/glass-card";
import Logo from "@/components/creations/logo";
import NavBar from "@/components/creations/nav-bar";
import { useIsMobile } from "@/hooks/use-mobile";
import { images } from "@/lib/constants";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { ReactNode } from "react";
import Image from "next/image";
import { Home, Palette, User, FolderOpen, Briefcase } from "lucide-react";

export default function HomeLayout({ children }: { children: ReactNode }) {
  const homeNavLinks = [
    {
      name: "Home",
      href: "/",
      icon: Home,
      childLinks: [
        { name: "About", href: "/#about", icon: null },
        { name: "Contacts", href: "/#footer", icon: null },
      ],
    },
    {
      name: "Creations",
      href: "/creations",
      icon: Palette,
      childLinks: [
        { name: "Projects", href: "/projects", icon: Briefcase },
        // { name: "Designs", href: "/designs", icon: FolderOpen },
      ],
    },
    // { name: "Profile", href: "/profile", icon: User },
  ];
  const isMobile = useIsMobile();
  return (
    <div
      className={cn(
        `h-screen w-screen overflow-hidden ${isMobile ? "p-4" : "flex items-center justify-around gap-8 p-8"}`,
      )}
    >
      <div className="flex justify-between">
        {isMobile && (
          <div className="flex gap-2">
            <Link href={"/"}>
              <Logo
                className={glassCardVariants({
                  variant: "strong",
                  className: " w-[42vw]",
                })}
              />
            </Link>
            <Image
              src={`/images/${images[0]}`}
              alt="Image"
              width={100}
              height={100}
              className="size-20"
            />
          </div>
        )}
        <GlassCard
          className={cn(
            `h-10 md:h-auto flex flex-col justify-center items-center md:grid relative max-w-min md:w-full hover:border-primary transition-all`,
          )}
        >
          <NavBar NavLinks={homeNavLinks} isMobile={isMobile} />
        </GlassCard>
      </div>

      <div className="pr-4 pl-2 md:p-8 my-4 md:m-0 h-full overflow-y-scroll thin-scrollbar flex-1">
        {children}
      </div>
    </div>
  );
}
